import { Skeleton } from "@/components/ui/skeleton";
import {
  CarouselNextSkeleton,
  CarouselPreviousSkeleton,
} from "@/components/ui/carousel";

export function AdvertiserCarouselSkeleton() {
  return (
    <div className="relative w-full">
      <CarouselPreviousSkeleton orientation="horizontal" />
      <div className="-ml-4 flex flex-row">
        <div className="min-w-0 shrink-0 grow-0 basis-full pl-4 lg:basis-1/2 xl:basis-1/3 xxl:basis-1/4">
          <Skeleton className="relative flex aspect-advertiserCardSm h-full w-full flex-col justify-between gap-0 overflow-hidden rounded-2xl bg-matchbus/10 sm:aspect-advertiserCardXl xxl:aspect-advertiserCardXl">
            <Skeleton className="imageContainer h-[300px] w-[400px] bg-matchbus/5"></Skeleton>
            <Skeleton className="textWrapper bg-matchbus/5"></Skeleton>
          </Skeleton>
        </div>
        <div className="min-w-0 shrink-0 grow-0 basis-full pl-4 lg:basis-1/2 xl:basis-1/3 xxl:basis-1/4">
          <Skeleton className="relative flex aspect-advertiserCardSm h-full w-full flex-col justify-between gap-0 overflow-hidden rounded-2xl bg-matchbus/10 sm:aspect-advertiserCardXl xxl:aspect-advertiserCardXl">
            <Skeleton className="imageContainer h-[300px] w-[400px] bg-matchbus/5"></Skeleton>
            <Skeleton className="textWrapper bg-matchbus/5"></Skeleton>
          </Skeleton>
        </div>
        <div className="min-w-0 shrink-0 grow-0 basis-full pl-4 lg:basis-1/2 xl:basis-1/3 xxl:basis-1/4">
          <Skeleton className="relative flex aspect-advertiserCardSm h-full w-full flex-col justify-between gap-0 overflow-hidden rounded-2xl bg-matchbus/10 sm:aspect-advertiserCardXl xxl:aspect-advertiserCardXl">
            <Skeleton className="imageContainer h-[300px] w-[400px] bg-matchbus/5"></Skeleton>
            <Skeleton className="textWrapper bg-matchbus/5"></Skeleton>
          </Skeleton>
        </div>
        <div className="min-w-0 shrink-0 grow-0 basis-full pl-4 lg:basis-1/2 xl:basis-1/3 xxl:basis-1/4">
          <Skeleton className="relative flex aspect-advertiserCardSm h-full w-full flex-col justify-between gap-0 overflow-hidden rounded-2xl bg-matchbus/10 sm:aspect-advertiserCardXl xxl:aspect-advertiserCardXl">
            <Skeleton className="aspect-advertiserCardImg h-[300px] w-[400px] bg-matchbus/5"></Skeleton>
            <Skeleton className="h-full bg-matchbus/5 p-4 pb-8"></Skeleton>
          </Skeleton>
        </div>
      </div>
      <CarouselNextSkeleton orientation="horizontal" />
    </div>
  );
}
